<template>
<div class="container">
  <!-- container -->
  <h1><small>メールアドレス変更</small></h1>
  <div class="section">

    <p class="alert alert-info">入力頂いたメールアドレス宛に、確認のメールをお送りさせて頂きます。メール内にあるURLをクリックすると変更が完了します。<br> メールアドレス変更完了後は、ログイン用のメールアドレスも変更となりますので、ご注意下さい。</p>

    <form class="mb-5" action="index.html" method="post">
      <div class="form-group p-3">
        <label for="password-input" class="col-form-label">新しいメールアドレス<span class="attention">※</span></label>
        <input type="email" class="form-control" id="password-input" v-model="email">
      </div>
      <br>
      <div class="btn-group" role="group" aria-label="group">
        <router-link to="/profile" class="btn btn-outline-info btn-lg">キャンセル</router-link>
        <a href="#" class="btn btn-primary btn-lg" :class="submitStyle" @click.prevent="submit()">メールアドレス変更</a>
      </div>
    </form>
  </div>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import util from 'util/lecturer'
import api from 'api'
import modal from 'util/modal'
export default {
  data () {
    return {
      email: '',
      isDisabled: false
    }
  },
  computed: {
    submitStyle () {
      return this.isValidEmail && !this.isDisabled ? '' : 'disabled'
    },
    isValidEmail () {
      return this.email && util.validateEmail(this.email)
    }
  },
  methods: {
    submit () {
      if (!this.isValidEmail) { return }
      this.isDisabled = true
      api.changeEmail(this, { email: this.email }).then(_ => {
        this.$router.push('/profile')
      }).catch(err => {
        if (err.status === 401) {
          modal.showLoginModal(this)
        } else {
          modal.showErrorModal(this, err)
        }
        this.isDisabled = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditEmail.vue?7b7d6be9